import React from 'react'
import PropTypes from 'prop-types'
import { createComponent, withTheme } from '@ycos/fela'
import { getFontStyles } from '@ycos/primitives'
import CoremediaPageContext from '@ycos/coremedia-page-context'
import LiveChatIcon from './LiveChatIcon'

const LiveChatButton = (props) => {
  const { brand, item } = props
  const { teaserTitle, ynapParameter } = item

  // this is set in Live Person when creating an engagement
  // default is live-chat-{brand}-embed
  const liveChatID = ynapParameter || `live-chat-${brand}-embed`
  return (
    <CoremediaPageContext.Consumer>
      {({ nativeapp }) =>
        (!nativeapp ? (
          <LiveChatWrapper id={liveChatID}>
            <OfflineButton>
              <IconWrapper>
                <LiveChatIcon />
              </IconWrapper>
              <OfflineButtonText>{teaserTitle}</OfflineButtonText>
            </OfflineButton>
          </LiveChatWrapper>
        ) : null)
      }
    </CoremediaPageContext.Consumer>
  )
}

const LiveChatWrapper = createComponent(
  'LiveChatWrapper',
  ({ theme }) => ({
    marginBottom: `${4 * theme.spacingMultiplier}px`,
    '> div[class*="LPMcontainer"]': {
      borderBottom: 'none !important',
      margin: '0 !important',
      display: 'block !important',
      boxShadow: 'none'
    },
    '> div > div[class*="active-state"]': {
      marginTop: `${-4 * theme.spacingMultiplier}px`,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },
    '> div > div[class*="active-state-white"]': {
      backgroundColor: theme.typography.colors.PrimaryWhite
    },
    '> div > div[class*="active-state-grey"]': {
      backgroundColor: theme.typography.colors.PrimaryGrey
    },
    '> div > div[class*="active-state-black"]': {
      backgroundColor: theme.typography.colors.PrimaryBlack
    },
    '> div > div > div[class*="icon"]': {
      backgroundColor: theme.typography.colors.PrimaryBlack,
      marginRight: `${1.25 * theme.spacingMultiplier}px`,
      paddingTop: `${0.25 * theme.spacingMultiplier}px`,
      height: '32px',
      width: '32px',
      borderRadius: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '> div > div > div[class*="text"]': {
      ...getFontStyles(theme.typography, { type: 'Heading', name: 'B6' }),
      color: theme.typography.colors.PrimaryBlack
    }
  }),
  'div'
)

const OfflineButton = createComponent(
  'OfflineButton',
  () => ({
    display: 'flex',
    alignItems: 'center'
  }),
  'div'
)

const OfflineButtonText = createComponent(
  'OfflineButtonText',
  ({ theme }) => ({
    ...getFontStyles(theme.typography, { type: 'Heading', name: 'B6' }),
    color: theme.typography.colors.SecondaryGreySteel
  }),
  'h2'
)

const IconWrapper = createComponent(
  'IconWrapper',
  ({ theme }) => ({
    backgroundColor: theme.typography.colors.SecondaryGreySteel,
    height: '32px',
    width: '32px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: `${1.25 * theme.spacingMultiplier}px`,
    paddingTop: `${0.25 * theme.spacingMultiplier}px`
  }),
  'div'
)

LiveChatButton.propTypes = {
  brand: PropTypes.oneOf(['nap', 'ton', 'mrp']).isRequired,
  item: PropTypes.shape({
    teaserTitle: PropTypes.string.isRequired,
    ynapParameter: PropTypes.string
  })
}

LiveChatButton.layoutVariant = 'isc-live-chat-embedded-button'

export default withTheme(LiveChatButton)
